
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#FFF","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M19.512 8.8a2.88 2.88 0 00-2.955-2.125L15.45 2.544a1.565 1.565 0 00-1.888-1.09l-1.442.387a1.542 1.542 0 00-1.118 1.238l-4.89 4.263-3.861 1.035a2.69 2.69 0 00-1.9 3.29L1.486 15.9a2.689 2.689 0 002.593 1.991c.019 0 .037-.003.055-.003l1.234 4.603c.107.398.362.73.718.936a1.533 1.533 0 001.17.155l.117-.032a1.544 1.544 0 001.09-1.888L7.25 17.135l1.387-.371 6.369 1.247a1.537 1.537 0 001.585.514l1.441-.387a1.543 1.543 0 001.09-1.888l-1.107-4.13a2.882 2.882 0 001.497-3.32zM9.077 15.686L7.033 8.057l4.18-3.646 3.306 12.34-5.442-1.066zm-1.718 6.271a.4.4 0 01-.282.489l-.117.031a.399.399 0 01-.489-.282L5.26 17.668l.887-.238 1.213 4.526zm-2.88-5.262a1.564 1.564 0 01-1.89-1.091L1.455 11.37c-.22-.821.27-1.67 1.092-1.89l3.438-.922 1.932 7.214-3.438.921zm13.258.34l-1.442.387a.402.402 0 01-.488-.283L12.134 3.433a.4.4 0 01.282-.488l1.442-.386a.399.399 0 01.489.282l3.672 13.705a.4.4 0 01-.282.488zm-.03-6.064l-.842-3.145a1.73 1.73 0 011.543 1.272c.195.728-.11 1.47-.7 1.873zM19.027 5.024L23.052.367l.865.748L19.89 5.77zM20.98 12.315l.374-1.08 5.815 2.021-.375 1.079zM20.516 7.939l6.032-1.616.296 1.104-6.033 1.616z"}})])])
          )
        }
      }
    